import { render, staticRenderFns } from "./ExerciseInfo.vue?vue&type=template&id=ae80231e&"
import script from "./ExerciseInfo.vue?vue&type=script&lang=js&"
export * from "./ExerciseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports